<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-if="dataLoaded">
      <v-card class="ret-card ret-card-wide">
        <v-card-title>
          <h3 class="headline">Přehled provedených prací (údržba DP Praha)</h3>
          <v-spacer></v-spacer>
          <ret-date-picker v-model="reportDate"></ret-date-picker>
          <v-btn icon :color="showEntireMonth ? 'accent' : ''" @click="toggleShowEntireMonth">
            <v-icon>view_list</v-icon>
          </v-btn>
          <v-btn text icon @click="downloadReport({downloadEntireMonth: true, format: 'excel'})">
            <v-icon>file_download</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div>
            <v-select
              v-model="filteredAccount"
              :label="$t('category')"
              :items="accounts"
              item-text="text"
              item-value="value"
              :menu-props="{bottom: true}"
              class="ret-filter-select"
            ></v-select>
          </div>
          <v-data-table
            :headers="headers"
            :items="items"
            :no-data-text="$t('no-data-available')"
            :footer-props="{ 'items-per-page-text': $t('rows-per-page'), 'items-per-page-options': [20,50,100,{ text: $t('all'), value: -1 }] }"
          >
            <template slot="item" slot-scope="props">
              <tr @click="onInterventionClicked(props.item)">
                <td v-for="headerName in headerNames" v-bind:class="getCellClass(props.item, headerName)"
                    :key="headerName">
                  {{ props.item[headerName] }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<style scoped>
  td.validation-error {
    background-color: #f4433666;
  }

  .input-group.ret-filter-select {
    display: inline-flex;
    max-width: 200px;
    padding-right: 16px;
  }
</style>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import moment from 'moment'
import FileSaver from 'file-saver'
import RetDatePicker from '../shared/components/ret-date-picker.vue'

export default {
  mixins: [displayHelpers],
  data () {
    return {
      dataLoaded: true,
      showEntireMonth: false,
      headers: [
        { text: 'Záruka', value: 'xPrgZaruka' },
        { text: 'č. EOV', value: 'assetNum' },
        { text: 'Číslo výměny', value: 'xPrgCisloVymeny' },
        { text: 'Ohlásil', value: 'issueReportedBy' },
        { text: 'Kód nebo popis závady, popis činnosti', value: 'issueDescription', minWidth: '300' },
        { text: 'Provedl', value: 'teamMembers' },
        { text: 'Ohlášeno', value: 'driveStartAt', align: 'right' },
        { text: 'Začátek', value: 'workStartAt', align: 'right' },
        { text: 'Konec', value: 'workEndAt', align: 'right' },
        { text: 'Na cestě (hod)', value: 'xDriveTime', align: 'right' },
        { text: 'Plošina (hod)', value: 'xPrgMontPlosina', align: 'right' },
        { text: 'Počet lidí', value: 'xTeamMembersQty', align: 'right' },
        { text: 'Účtováno jako oprava', value: 'xPrgOprava', align: 'right' },
        { text: 'Účtováno jako mech.?', value: 'xPrgMCategory', align: 'right' },
        { text: 'Porucha? (ne)', value: 'issueFailure', align: 'right' },
        { text: 'Porucha trvá', value: 'issuePending', align: 'right' },
        { text: 'Spotřebovaný materiál účtovaný zvlášť', value: 'xMaterial', minWidth: '300' },
        { text: 'Celkem materiál', value: 'xMaterialSum', align: 'right' },
        { text: 'Cena dle ceníku výkonů', value: 'xPrgCenaDleCenikuVykonu', align: 'right' },

        { text: 'Práce paušál', value: 'xPrgPracePausal', align: 'right' },
        { text: 'Práce opravy', value: 'xPrgPraceOpravy', align: 'right' },
        { text: 'Na cestě', value: 'xDriveManTime', align: 'right' },
        { text: 'Poruchohodiny výhybek', value: 'xPrgFailureTime', align: 'right' }
      ],
      filteredAccount: undefined,
      accounts: [
        { text: '', value: '' },
        { text: 'E', value: 'E' },
        { text: 'M', value: 'M' }
      ]
    }
  },
  computed: {
    items () {
      return this.$store.state.reportItems
    },
    headerNames () {
      return this.headers.map(header => header.value)
    },
    reportDate: {
      get () {
        return this.$store.state.report.date
      },
      set (val) {
        this.$store.commit('setReport', { param: 'date', val: val })
      }
    }
  },
  methods: {
    toggleShowEntireMonth () {
      this.showEntireMonth = !this.showEntireMonth
      this.downloadReport({ format: 'json' })
    },
    formatItems (items, headers) {
      // Applies formatting filters specified in the headers on the provided items
      for (let header of headers) {
        // let key = header.value
        if (header.format) {
          for (let item of items) {
            // formatting the cell text
            item[header.value] = this.dynamicFilter(item[header.value], header.format)
          }
        }
      }
      return items
    },
    onInterventionClicked (row) {
      this.$router.push({ name: `issues/id`, params: { id: row.issueId, interventionId: row.id } })
    },
    downloadReport ({ downloadEntireMonth, format }) {
      this.dataLoaded = false
      const entireMonth = downloadEntireMonth || this.showEntireMonth
      let dateFrom
      let dateTo
      const issueCategory = this.filteredAccount ? this.filteredAccount : undefined // Not sending '' to BE

      if (!entireMonth) {
        dateFrom = moment(this.reportDate).startOf('day').format()
        dateTo = moment(this.reportDate).endOf('day').format()
      } else {
        dateFrom = moment(this.reportDate).startOf('month').format()
        dateTo = moment(this.reportDate).endOf('month').format()
      }

      if (format === 'excel') {
        return this.$store.dispatch('downloadReportExcel', { name: 'prg', dateFrom, dateTo, issueCategory })
          .then((response) => {
            FileSaver.saveAs(response.data, 'report.xlsx')
            this.dataLoaded = true
          })
      }
      return this.$store.dispatch('downloadReport', { name: 'prg', dateFrom, dateTo, issueCategory })
        .then((response) => {
          this.dataLoaded = true
        })
    },
    getCellClass (item, headerName) {
      let result = {}
      const header = this.headers.find(header => header.value === headerName)
      // Aligned right
      if (header.align === 'right') {
        result['text-right'] = true
      }
      // Width-300
      if (header.minWidth === '300') {
        result['ret-table-min-300'] = true
      }
      // Validation error
      if (item.errors && item.errors[headerName]) {
        result['validation-error'] = true
      }
      return result
    }
  },
  watch: {
    reportDate: {
      handler (val) {
        this.downloadReport({ format: 'json' })
      },
      immediate: true
    },
    filteredAccount (val) {
      this.downloadReport({ format: 'json' })
    }
  },
  components: {
    RetDatePicker
  }
}
</script>
